import { Leaf } from "lucide-react";
import { useSite } from "@/context/SiteContext";
import { Cta } from "./Cta";

export const TrustBar = () => {
  const { content } = useSite();
  const items = content.trust_bar || [];
  if (!items.length) return null;
  return (
    <div data-testid="trust-bar" className="bg-forest text-bone">
      <ul className="mx-auto flex max-w-7xl items-center gap-x-8 overflow-x-auto whitespace-nowrap px-5 py-2.5 text-sm font-semibold [scrollbar-width:none] sm:justify-center">
        {items.map((t) => (
          <li key={t} className="flex items-center gap-2"><Leaf className="h-3.5 w-3.5 text-gold" aria-hidden />{t}</li>
        ))}
      </ul>
    </div>
  );
};

const LangToggle = () => {
  const { lang, setLang, t } = useSite();
  return (
    <div role="group" aria-label={t("lang_switch")} data-testid="lang-toggle" className="flex rounded-full border border-forest/20 bg-white p-0.5 text-sm font-bold">
      {[["en", "EN"], ["hi", "हिंदी"]].map(([code, label]) => (
        <button key={code} type="button" onClick={() => setLang(code)} aria-pressed={lang === code} data-testid={`lang-toggle-${code}`}
          className={`min-h-[36px] rounded-full px-3 transition-colors ${lang === code ? "bg-forest text-bone" : "text-forest hover:bg-sand"}`}>{label}</button>
      ))}
    </div>
  );
};

export const Nav = () => {
  const { t } = useSite();
  return (
    <header data-testid="site-header" className="sticky top-0 z-40 border-b border-forest/10 bg-bone/85 backdrop-blur-xl">
      <div className="mx-auto flex h-16 max-w-7xl items-center justify-between px-5 sm:px-8">
        <a href="#top" data-testid="nav-logo" className="flex items-center" aria-label="Tayyiba Naturals home">
          <img src="/img/logo-horizontal.webp" alt="Tayyiba Naturals" width="360" height="120" className="h-11 w-auto object-contain sm:h-12" />
        </a>
        <div className="flex items-center gap-2">
          <LangToggle />
          <Cta kind="call" name="nav_call" position="header" variant="outline" size="sm" className="hidden md:inline-flex" />
          <Cta kind="consult" name="nav_consultation" position="header" size="sm" label={t("nav_consult")} className="hidden sm:inline-flex" />
        </div>
      </div>
    </header>
  );
};
